// AI agent categories for the "By Task" stacked breakdown — kept in sync with the
// agent keys configured per-organisation in Organisation Management's AI Models
// modal (see pages/OrgMgmt/aiModelsAllocation.js AI_AGENTS). Colors are a qualitative
// categorical palette (open-ended category, no existing semantic color per agent) —
// same approach as EmissionsTrends.jsx's TARGET_PALETTE, not the lime/limeShade brand
// tokens, which are reserved for UI chrome.
export const TASK_TYPES = [
  { key: "report_writer", label: "Report Writer", color: "#7C3AED" },
  { key: "chat", label: "Chat", color: "#0EA5E9" },
  { key: "mapping", label: "Mapping", color: "#F59E0B" },
  { key: "review", label: "Review", color: "#10B981" },
];

export const TASK_TYPE_KEYS = TASK_TYPES.map((t) => t.key);

export function getTaskTypeColor(key) {
  return TASK_TYPES.find((t) => t.key === key)?.color || "#A0AEC0";
}
